import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Box,
  Button,
  ButtonGroup,
  Checkbox,
  Dialog,
  IconButton,
  Modal,
  Slide,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import CloseIcon from '@mui/icons-material/Close';
import { useSnackbar } from 'notistack';
import InputField from '../../../reusable-component/InputField';
import LoadingIcon from '../../../reusable-component/LoadingIcon';
import { fetchRuleSelectorMetricList } from "../../../api's/DataProcessorApi";
import generateAlias from '../../../utils/generateAlias';
import LlmDqRules from '../llm-mapper-component/LlmDqRules';

const styleLoading = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});
const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
function NodeModalLLMDQRules({ open, handleClose, nodeId, nodeName, nodes, edges, changeNodeName, setNodes }) {
  const { enqueueSnackbar } = useSnackbar();
  const INITIALSTATE = {
    alias: generateAlias(nodeName, nodeId),
    df: '',
    dqRules: [],
  };

  // all states

  const [formField, setFormField] = useState(INITIALSTATE);
  const [value, setValue] = useState(0);
  const [disableForm, setDisableForm] = useState(false);
  const [fetchedHeader, setFetchedHeader] = useState([]);
  const [headerName, setHeaderName] = useState([]);
  const [tempHeader, setTempHeader] = useState([]);
  const [refreshModalOpen, setRefreshModalOpen] = useState(false);
  const [formattedFields, setFormattedFields] = useState([]);
  const [columnName, setColumnName] = useState([]);
  const [dqRules, setDqRules] = useState([]);
  const [metricList, setMetricList] = useState([]);
  // const [headers, setHeaders] = useState([]);

  const handleRefreshModalOpen = () => setRefreshModalOpen(true);
  const handleRefreshModalClose = () => setRefreshModalOpen(false);

  const getRuleSelectorMetricList = async () => {
    try {
      const response = await fetchRuleSelectorMetricList();
      if (response.status === 200) {
        setMetricList(response.data);
      }
    } catch (error) {
      enqueueSnackbar('Error while fetching Metric List!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
  };

  const compareTwoArrayOfObjects = (first_array_of_objects, second_array_of_objects) =>
    first_array_of_objects.length === second_array_of_objects.length &&
    first_array_of_objects.every((element_1) =>
      second_array_of_objects.some(
        (element_2) =>
          element_1.header === element_2.header &&
          element_1.tableAlias === element_2.tableAlias &&
          element_1.alias === element_2.alias &&
          element_1.checked === element_2.checked
      )
    );

  const handleFormsubmit = async (e) => {
    e.preventDefault();

    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes') || '[]');

    if (getAllNodes.length > 0) {
      const newFormData = getAllNodes.filter((el) => el.nodeId !== nodeId);
      sessionStorage.setItem('allNodes', JSON.stringify(newFormData));
    }

    let y_axis;

    nodes.forEach((el) => {
      if (nodeId === el.id) {
        y_axis = parseInt(el.position.x, 10);
        el.data.label = formField.alias;
      }
    });

    const newHeaderName = [];

    headerName.forEach((item) => {
      newHeaderName.push({ ...item, tableAlias: formField.alias });
    });

    let equalArray;
    if (tempHeader.length > 0) {
      equalArray = compareTwoArrayOfObjects(tempHeader, newHeaderName);
    }

    const connectedNodes = [];

    if (!equalArray && tempHeader.length > 0) {
      edges.forEach((el) => {
        if (el.source === nodeId) connectedNodes.push(el.target);
      });

      let count = 0;

      setNodes((nds) =>
        nds.map((node) => {
          if (count <= connectedNodes.length && node.id === connectedNodes[count]) {
            node.position.x += 0.1;
            count++;
          }

          return node;
        })
      );
    }

    sessionStorage.setItem('updatedNodes', JSON.stringify(connectedNodes));

    const updatedFormField = { ...formField, dqRules };

    setHeaderName(newHeaderName);

    const sendFormData = {
      y_axis,
      nodeId,
      nodeName,
      formField: updatedFormField,
      disabled: true,
      step_name: nodeName,
      headerName: newHeaderName,
      columnName,
      fetchedHeader,
      dqRules,
    };

    changeNodeName(nodes);

    setDisableForm(true);

    sessionStorage.setItem('node', JSON.stringify(nodes));
    sessionStorage.setItem('edges', JSON.stringify(edges));

    const fetchNodesData = JSON.parse(sessionStorage.getItem('allNodes') || '[]');
    fetchNodesData.push(sendFormData);

    sessionStorage.setItem('allNodes', JSON.stringify(fetchNodesData));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node') || '[]');
    getElements.push(nodeId);
    sessionStorage.setItem('saved_node', JSON.stringify(getElements));
  };

  const refreshAllState = () => {
    handleRefreshModalOpen();

    let updateNodes = JSON.parse(sessionStorage.getItem('updatedNodes')) || [];

    let count = 0;

    setNodes((nds) =>
      nds.map((node) => {
        if (count <= updateNodes.length && node.id === updateNodes[count]) {
          node.position.x -= 0.1;
          count++;
        }

        return node;
      })
    );

    updateNodes = updateNodes.filter((el) => el !== nodeId);

    sessionStorage.setItem('updatedNodes', JSON.stringify(updateNodes));

    const findSrcNodeId = [];

    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (findSrcNodeId.length === 0) {
      setFormField(INITIALSTATE);
      setDisableForm(false);
      setFetchedHeader([]);
      setHeaderName([]);

      enqueueSnackbar('No source node is connected !!!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
      handleRefreshModalClose();
      return;
    }

    let nodesExist = false;

    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        nodesExist = true;
      }
    });

    if (store && findSrcNodeId) {
      let header = [];
      let prev_alias;
      let prev_nodeName;

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            header.push(...node.headerName);
            prev_alias = node.formField.alias;
            prev_nodeName = node.step_name;
          }
        });
      });

      setFormField({ ...formField, df: prev_alias });

      const newArr = [];

      if (prev_nodeName === 'Join') {
        header.forEach((el) => {
          const exist = el.header.split('.').length;

          if (exist === 2) {
            const head = el.header.split('.')[1];
            newArr.push({ ...el, header: el.alias ? el.alias : head });
          }
        });
      }
      if (newArr.length > 0) {
        header = newArr;
      }

      const uniqueHeader = [];

      const uniqueArray = header.filter((element) => {
        const isDuplicate = uniqueHeader.includes(element.header);

        if (!isDuplicate) {
          uniqueHeader.push(element.header);
          return true;
        }

        return false;
      });

      // const head = [];

      const newHeader = uniqueArray.map((el) => {
        return { ...el, header: el.alias ? el.alias : el.header, alias: el.alias ? '' : el.alias };
      });

      // newHeader.forEach((el) => {
      //   head.push({ label: el.header });
      // });

      // setHeaders(head);

      if (nodesExist) {
        store.forEach((node) => {
          if (node.nodeId === nodeId) {
            setFormField(node.formField);
            setDqRules(node.formField.dqRules);
            setFormattedFields(
              node.headerName.map((item) => ({
                fieldName: item.header,
                fieldValues: [item.sampleValue1, item.sampleValue2],
              }))
            );
            setHeaderName(node.headerName);

            const nonExistingHeader = [];
            node.fetchedHeader.forEach((item) => {
              const index = newHeader.findIndex((x) => x.header === item.header);

              if (index !== -1) {
                nonExistingHeader.push(item);
              }
            });

            newHeader.forEach((el) => {
              const index = nonExistingHeader.findIndex((x) => x.header === el.header);

              if (index === -1) {
                nonExistingHeader.push({
                  ...el,
                  header: el.alias ? el.alias : el.header,
                  alias: el.alias ? '' : el.alias,
                });
              }
            });

            setFetchedHeader(nonExistingHeader);
          }
        });
      } else {
        setFetchedHeader(newHeader);
      }
    }
    enqueueSnackbar('Data Refreshed!!!', {
      variant: 'Success',
      autoHideDuration: 3000,
      anchorOrigin: { vertical: 'top', horizontal: 'right' },
    });
    handleRefreshModalClose();
  };
  const handleResetForm = () => {
    setFormField(INITIALSTATE);
  };
  const handleEdit = (e) => {
    e.preventDefault();
    setDisableForm(false);
    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        setTempHeader(headerName);
      }
    });
    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes'));

    getAllNodes.forEach((el) => {
      if (el.nodeId === nodeId) {
        el['disabled'] = false;
      }
    });

    sessionStorage.setItem('allNodes', JSON.stringify(getAllNodes));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node'));

    const newSavedElement = getElements.filter((el) => el !== nodeId);

    sessionStorage.setItem('saved_node', JSON.stringify(newSavedElement));
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = fetchedHeader.map((n) => {
        const all = {
          header: n.header,
          checked: true,
          sampleValue1: n.sampleValue1 || '',
          sampleValue2: n.sampleValue2 || '',
        };
        return all;
      });
      setFetchedHeader(newSelecteds);
      setHeaderName(newSelecteds);
    } else {
      const newSelecteds = fetchedHeader.map((n) => {
        const all = {
          header: n.header,
          checked: false,
          sampleValue1: '',
          sampleValue2: '',
        };
        return all;
      });
      setFetchedHeader(newSelecteds);
      setHeaderName([]);
    }
  };

  const handleChange = (event, newValue) => {
    const incompleteSamples = headerName.some((column) => !column.sampleValue1 || !column.sampleValue2);

    if (incompleteSamples) {
      enqueueSnackbar(
        'Please provide both Sample Value 1 and Sample Value 2 for all selected columns before proceeding.',
        {
          variant: 'warning',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        }
      );
    } else {
      setValue(newValue);
    }
  };

  const getSourceData = () => {
    const findSrcNodeId = [];
    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (store && findSrcNodeId) {
      let header = [];
      let prev_alias;
      let prev_nodeName;

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            header.push(...node.headerName);
            prev_alias = node.formField.alias;
            prev_nodeName = node.step_name;
          }
        });
      });

      setFormField({ ...formField, df: prev_alias });

      const newArr = [];

      if (prev_nodeName === 'Join') {
        header.forEach((el) => {
          const exist = el.header.split('.').length;

          if (exist === 2) {
            const head = el.header.split('.')[1];
            newArr.push({ ...el, header: el.alias ? el.alias : head });
          }
        });
      }
      if (newArr.length > 0) {
        header = newArr;
      }

      const uniqueHeader = [];

      const uniqueArray = header.filter((element) => {
        const isDuplicate = uniqueHeader.includes(element.header);

        if (!isDuplicate) {
          uniqueHeader.push(element.header);
          return true;
        }

        return false;
      });

      const head = [];
      const newHeader = uniqueArray.map((el) => ({
        ...el,
        header: el.alias ? el.alias : el.header,
        alias: el.alias ? el.alias : '',
      }));

      newHeader.forEach((el) => {
        head.push({ label: el.header });
      });

      setFetchedHeader(newHeader);
      setColumnName(newHeader.map((item) => ({ id: item.header, label: item.header })));

      store.forEach((node) => {
        if (node.nodeId === nodeId) {
          setFormField(node.formField);
          setDqRules(node.formField.dqRules);
          setFormattedFields(
            node.headerName.map((item) => ({
              fieldName: item.header,
              fieldValues: [item.sampleValue1, item.sampleValue2],
            }))
          );
          setHeaderName(node.headerName);
          setFetchedHeader(node.fetchedHeader);
          setColumnName(node.columnName);
          setTempHeader(node.headerName);

          if (node.disabled) {
            setDisableForm(node.disabled);
          }
        }
      });
    }
  };

  const isSelected = (name) => {
    const selectedIndex = headerName.findIndex((object) => object.header === name);
    return selectedIndex !== -1;
  };

  const handleHeaderChange = (obj) => {
    const selectedIndex = headerName.findIndex((object) => {
      return object.header === obj.header;
    });

    if (selectedIndex === -1 && obj.checked) {
      setHeaderName([...headerName, obj]);
      console.log(obj);
      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              header: obj.header,
              checked: true,
              sampleValue1: obj.sampleValue1,
              sampleValue2: obj.sampleValue2,
            };
          }

          return object;
        })
      );
    }

    if (selectedIndex !== -1 && obj.checked) {
      console.log(obj);
      setHeaderName((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              header: obj.header,
              checked: true,
              sampleValue1: obj.sampleValue1 ? obj.sampleValue1 : '',
              sampleValue2: obj.sampleValue2 ? obj.sampleValue2 : '',
            };
          }

          return object;
        })
      );

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              header: obj.header,
              checked: true,
              sampleValue1: obj.sampleValue1,
              sampleValue2: obj.sampleValue2,
            };
          }

          return object;
        })
      );
    }

    if (selectedIndex !== -1 && !obj.checked) {
      setHeaderName((current) => current.filter((object) => object.header !== obj.header));

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.header === obj.header) {
            return {
              ...object,
              checked: false,
              sampleValue1: '',
              sampleValue2: '',
            };
          }

          return object;
        })
      );
    }
  };

  useEffect(() => {
    setFormField(INITIALSTATE);
    setDisableForm(false);
    getSourceData();
    getRuleSelectorMetricList();
  }, [nodeId]);

  const store = JSON.parse(sessionStorage.getItem('allNodes'));

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        style={{ width: '70%', marginLeft: '30%' }}
      >
        <form autoComplete="off" onSubmit={handleFormsubmit}>
          <AppBar sx={{ position: 'relative', backgroundColor: '#fff' }}>
            <Toolbar>
              <IconButton edge="start" onClick={handleClose} aria-label="close" sx={{ color: '#00043C' }}>
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1, color: '#00043C' }} variant="h6" component="div">
                {nodeName}
              </Typography>
              <Tooltip title="Refresh Schema" placement="left">
                <IconButton
                  disabled={disableForm}
                  edge="start"
                  onClick={refreshAllState}
                  aria-label="close"
                  sx={{ color: '#00043C' }}
                >
                  <RotateLeftIcon />
                </IconButton>
              </Tooltip>
              <ButtonGroup variant="contained" aria-label="outlined primary button group">
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleResetForm}
                  disabled={disableForm}
                  className="outlined-button-color"
                >
                  Clear
                </Button>
                <Button size="small" variant="outlined" className="outlined-button-color" onClick={handleEdit}>
                  Edit
                </Button>
                <Button type="submit" size="small" variant="contained" disabled={disableForm} className="button-color">
                  Submit
                </Button>
              </ButtonGroup>
            </Toolbar>
          </AppBar>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              variant="fullWidth"
              sx={{
                width: '100%',
                color: '#000',
                '& button': { backgroundColor: '#eee' },
                '& button:focus': { color: 'white', backgroundImage: 'linear-gradient(to right, #4880EC, #019CAD)' },
                '& button.Mui-selected': {
                  color: 'white',
                  backgroundImage: 'linear-gradient(to right, #4880EC, #019CAD)',
                },
              }}
            >
              <Tab label="Select Columns" {...a11yProps(0)} disabled={disableForm} />
              <Tab label="Generate Rules" {...a11yProps(1)} disabled={disableForm} />
            </Tabs>
          </Box>
          {/* Tab content */}
          <TabPanel value={value} index={0} sx={{ width: '100%' }}>
            <TableContainer sx={{ maxHeight: 500 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <Checkbox
                        color="primary"
                        disabled={disableForm}
                        checked={fetchedHeader.length === headerName.length}
                        onChange={handleSelectAllClick}
                      />
                      Select Columns
                    </TableCell>
                    <TableCell>Columns</TableCell>
                    <TableCell>Sample Value 1</TableCell>
                    <TableCell>Sample Value 2</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {fetchedHeader.map((row, i) => {
                    const isItemSelected = isSelected(row.header);
                    return (
                      <TableRow
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={i}
                        selected={isItemSelected}
                      >
                        <TableCell width="25%">
                          <Checkbox
                            checked={isItemSelected}
                            disabled={disableForm}
                            onChange={(event) =>
                              handleHeaderChange({
                                header: row.header,
                                checked: event.target.checked,
                                sampleValue1: row.sampleValue1 ? row.sampleValue1 : '',
                                sampleValue2: row.sampleValue2 ? row.sampleValue2 : '',
                              })
                            }
                            inputProps={{ 'aria-label': 'controlled' }}
                          />
                        </TableCell>
                        <TableCell width="25%">{row.header}</TableCell>

                        <TableCell width="25%">
                          {isItemSelected && (
                            <InputField
                              name="sampleValue1"
                              label="Sample Value 1"
                              value={row.sampleValue1}
                              onChange={(event) =>
                                handleHeaderChange({
                                  header: row.header,
                                  checked: row.checked,
                                  sampleValue1: event.target.value,
                                  sampleValue2: row.sampleValue2 ? row.sampleValue2 : '',
                                })
                              }
                              size="small"
                              disabled={disableForm || !isItemSelected}
                              required={isItemSelected}
                              hidden={!isItemSelected}
                            />
                          )}
                        </TableCell>
                        <TableCell width="25%">
                          {isItemSelected && (
                            <InputField
                              name="sampleValue2"
                              label="Sample Value 2"
                              value={row.sampleValue2}
                              onChange={(event) =>
                                handleHeaderChange({
                                  header: row.header,
                                  checked: row.checked,
                                  sampleValue1: row.sampleValue1 ? row.sampleValue1 : '',
                                  sampleValue2: event.target.value,
                                })
                              }
                              size="small"
                              disabled={disableForm || !isItemSelected}
                              required={isItemSelected}
                            />
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </TabPanel>
          <TabPanel value={value} index={1} sx={{ width: '100%' }}>
            <LlmDqRules
              disableForm={disableForm}
              headerName={headerName}
              setHeaderName={setHeaderName}
              columnName={columnName}
              formattedFields={formattedFields}
              setFormattedFields={setFormattedFields}
              dqRules={dqRules}
              setDqRules={setDqRules}
              metricList={metricList}
            />
          </TabPanel>
        </form>
      </Dialog>
      <Modal open={refreshModalOpen} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={styleLoading}>
          <LoadingIcon />
        </Box>
      </Modal>
    </div>
  );
}

export default NodeModalLLMDQRules;
